module.exports = __webpack_public_path__ + "img/minus.634256ac.svg";